import { kmsClient } from 'api';
import { useLazyQuery } from '@apollo/react-hooks';
import { FACEBOOK_ACCOUNTS_QUERY } from './facebookAccounts.query';
import { FacebookAccountsQuery, FacebookAccountsQueryVariables } from './__generated__/FacebookAccountsQuery';

export const useFacebookAccountsQuery = () =>
  useLazyQuery<FacebookAccountsQuery, FacebookAccountsQueryVariables>(FACEBOOK_ACCOUNTS_QUERY, {
    client: kmsClient
  });
